export default __webpack_public_path__ + "static/O0266-eb88e1d596b680fade1cd795f0d5be1b.png";